export const SHIP_DATE_FUTURE_MESSAGE = 'Ship date cannot be in the future.';
//# sourceMappingURL=ship-date-future-message.js.map